import { Component, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormControl, FormGroup } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { BlockUI } from 'primeng/blockui';
import { ProgressSpinner } from 'primeng/progressspinner';
import { BusinessGroupedModel } from '@features/business/models/business.model';
import { OfficeFilterModel } from '@features/business/models/office.model';
import { BusinessLogo } from "@shared/components/business-logo/business-logo";

@Component({
  selector: 'app-office-filter',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    MultiSelectModule,
    BusinessLogo,
    BlockUI,
    ProgressSpinner
  ],
  templateUrl: './office-filter.html',
  styleUrl: './office-filter.scss',
})
export class OfficeFilter {
  businessGroupOptions = input<BusinessGroupedModel[]>([]);
  isLoading = input<boolean>(false);

  filterChange = output<OfficeFilterModel>();
  clearFilters = output<void>();

  filterForm: FormGroup = new FormGroup({
    searchText: new FormControl(''),
    selectedBusinesses: new FormControl<string[]>([])
  });

  onSearch() {
    const filters: OfficeFilterModel = {
      searchText: this.filterForm.get('searchText')?.value?.trim() || undefined,
      selectedBusinesses: this.filterForm.get('selectedBusinesses')?.value || undefined
    };

    this.filterChange.emit(filters);
  }

  onClearFilters() {
    this.filterForm.reset();
    this.clearFilters.emit();
  }

  getBusinessOptions() {
    return this.businessGroupOptions().flatMap(group =>
      group.Business?.map(business => ({
        label: business.Name,
        value: business.Id,
        logoUrl: business.LogoUrl
      })) || []
    );
  }
}